import { render, staticRenderFns } from "./EditCulvert.vue?vue&type=template&id=1b088ec6"
import script from "./EditCulvert.vue?vue&type=script&lang=ts"
export * from "./EditCulvert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports